import createComponent from 'styles/fela/createComponent';

export const ShowHidePassword = createComponent(({ theme }) => ({
  color: theme.color.inputColor,
  cursor: 'pointer',
  position: 'absolute',
  right: '5px',
  marginTop: '0.4rem',
  top: theme.margin.large,
  background: 'none',
  border: 'none',
  padding: 0,
  lineHeight: 0,
}), 'button');
